/**
 * Single source of truth for Disputes' volumetric-weight formula:
 * l x b x h / 5000, to 2dp — the same formula the generator back-solved
 * against in data/noberoDisputes.js (see that file's header and
 * noberoDisputes.test.js's own "volKg is always consistent with the row's
 * dims" guard).
 *
 * RecordSections.js's weight-comparison readout and EvidenceIntake.js's live
 * dimension readout both import this rather than recomputing the arithmetic
 * inline, so the drawer's two volumetric numbers (the existing row's, and
 * whatever the merchant is about to submit) and the grid can never quote
 * different figures for the same box.
 */
export const VOLUMETRIC_DIVISOR = 5000

export function volumetricKg(l, b, h) {
  const ln = Number(l)
  const bn = Number(b)
  const hn = Number(h)
  if (!(ln > 0 && bn > 0 && hn > 0)) return 0
  return Math.round(((ln * bn * hn) / VOLUMETRIC_DIVISOR) * 100) / 100
}
